import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'




/**
 * 列表
 * @param {Object} data
 */
export function getPageList(data) {
  return fetch({
    url: '/auth/customer/permissionLift/pageList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 删除
 */
export function deletePermissionLift(data) {
  return fetch({
    url: '/auth/customer/permissionLift/delete',
    method: 'POST',
    data
  })
}


/**
 * 列表
 * @param {Object} data
 */
export function getTemplateMessageList(data) {
  return fetch({
    url: '/foreign/wx/getTemplateMessageList',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/CustomerFollowManagement/index.js